import pkg from 'keycloak-js';

const Keycloak = pkg.default || pkg; // Fallback indien geen default export

const keycloak = new Keycloak({
  url: 'https://dev.keycloak.zipster.care/',
  realm: 'zipster',
  clientId: 'zipster-web'
});

keycloak.onReady = authenticated => {
  console.log("✅ Keycloak ready. Authenticated:", authenticated);
};
keycloak.onAuthSuccess = () => {
  console.log("🎉 Auth success");
};
keycloak.onAuthError = error => {
  console.error("❌ Auth error", error);
};
keycloak.onAuthLogout = () => {
  console.log("🚪 User logged out");
};
keycloak.onTokenExpired = () => {
  console.log("⏰ Token expired");
};

export default keycloak;